angular.module("questionarioAdv.module")
    .component("operazione", {
        templateUrl: "ng/components/questionarioAdv/operazione/operazione.view.html",
        bindings: {
            model: "=",
            exportValidationComponent: '&'
        },
        controllerAs: 'operazioneCtrl',
        controller: Operazione
    })

function Operazione(
    $scope,
    $timeout
) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            finalita: null,
            areaGeograficaDestProd: null
        }
        setDefaulValue();
        validateComponent();
    }
    self.handleChange = function (tipo, valueSelected) {
        self.model[tipo].forEach(function (element) {
            if (element.value == valueSelected.value) {
                element.selected = true;
            } else {
                element.selected = false;
            }
        })
        validateComponent();
    }

    var validateComponent = function () {
        $timeout(function () {
            if ($scope.operazione) {
                console.log("Il form operazione è:", $scope.operazione.$valid);
                self.exportValidationComponent({
                    valid: $scope.operazione.$valid
                })
            }


        }, 500)

    }

    var setDefaulValue = function () {
        self.supportModel.finalita = self.model && self.model.finalita && self.model.finalita.find(function (element) {
            return element.selected == true;
        })

        self.supportModel.areaGeograficaDestProd = self.model && self.model.area && self.model.area.find(function (element) {
            return element.selected == true;
        })
    }
}